import { render, staticRenderFns } from "./ExamsList.vue?vue&type=template&id=77f5bda0&scoped=true&"
import script from "./ExamsList.vue?vue&type=script&lang=js&"
export * from "./ExamsList.vue?vue&type=script&lang=js&"
import style0 from "./ExamsList.vue?vue&type=style&index=0&id=77f5bda0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f5bda0",
  null
  
)

export default component.exports